import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-cream border-y border-beige" data-id="element-126">
      <div className="max-w-4xl mx-auto" data-id="element-127">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white border border-beige rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-sm" data-id="element-128">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold-gradient" data-id="element-129"></div>

          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gold/10 text-gold mb-8 border border-gold/20" data-id="element-130">
            <ShieldCheck size={48} data-id="element-131" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6 text-forest" data-id="element-132">
            🛡️ Garantía total de 7 días
          </h2>

          <div className="space-y-6 text-lg text-ink max-w-2xl mx-auto font-medium" data-id="element-133">
            <p data-id="element-134">
              Abre los 7 tomos. Revisa los 5 bonos. Úsalos en tu clase más
              difícil esta semana.
            </p>
            <p className="font-bold text-terracotta" data-id="element-135">
              Si sientes que tus alumnos no respondieron mejor, o que el
              material no te ahorró horas de preparación:
            </p>
            <p className="text-forest font-bold text-xl" data-id="element-136">
              Te devolvemos el 100% de tu dinero. Sin preguntas. Sin
              formularios. Sin complicaciones.
            </p>
            <p className="text-sm text-warmgray mt-8" data-id="element-137">
              Porque si el material no te da el valor que prometemos, no
              queremos quedarnos con tu dinero.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}